import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

import SinglePhotoIcon from '../../../../components/icons/SinglePhotoIcon';
import { isPhoto, isVideo } from './helpers';
import VideoIcon from '../../../../components/icons/VideoIcon';

const propTypes = {
  uploadItem: PropTypes.shape({
    file: PropTypes.shape({
      name: PropTypes.string,
    }),
    progressEvent: PropTypes.object,
    success: PropTypes.bool,
    error: PropTypes.object,
  }).isRequired,
};

const UploadProgressTrackingFile = ({ uploadItem }) => {
  const { success, error, progressEvent, file, startDate } = uploadItem;

  const isWaiting = !success && !error && !progressEvent;

  const progressBarWidth =
    success || error
      ? '100'
      : (progressEvent?.loaded / progressEvent?.total) * 100;

  const timeDiff = moment().diff(startDate, 'seconds');
  const uploadSpeed = progressEvent
    ? (progressEvent.loaded / timeDiff / 1024).toFixed(2)
    : undefined;

  const classes = classNames({
    'mb-1': true,
  });

  const progressBarClasses = classNames({
    'progress-bar': true,
    'progress-bar-success': !!success,
    'progress-bar-danger': !!error,
    'progress-bar-animating': !!progressEvent,
    'd-none': isWaiting,
  });

  const statusLabel = (() => {
    if (success) {
      return 'Completed';
    }

    if (error) {
      return 'Upload Failed!';
    }

    if (isWaiting) {
      return 'Waiting...';
    }

    // Default progressEvent
    return timeDiff > 0
      ? `Upload speed: ${
          uploadSpeed > 1024
            ? `${(uploadSpeed / 1024).toFixed(2)}MB/s`
            : `${uploadSpeed}KB/s`
        }`
      : 'Calculating upload speed...';
  })();

  const statusLabelClasses = classNames({
    'text-xs d-block mt-1': true,
    'text-success': !!success,
    'text-danger': !!error,
    'text-faded': isWaiting,
  });

  return (
    <div className={classes}>
      <div className="mt-0 mb-1 text-dark d-flex align-items-center">
        {isPhoto(file) && (
          <SinglePhotoIcon size={20} color="#798588" className="mr-1" />
        )}
        {isVideo(file) && (
          <VideoIcon size={20} color="#798588" className="mr-1" />
        )}
        <p className="mb-0">{file.name}</p>
      </div>
      <Fragment>
        {!isWaiting && (
          <div className="progress">
            <div
              className={progressBarClasses}
              style={{ width: `${progressBarWidth}%` }}
            />
          </div>
        )}
        <div className="d-flex">
          <span className={statusLabelClasses}>{statusLabel}</span>
        </div>
      </Fragment>
    </div>
  );
};

UploadProgressTrackingFile.propTypes = propTypes;

export default UploadProgressTrackingFile;
